const actions = {
  SET_STATE: 'directory/SET_STATE',
  GET_DIRECTORY_RECORD: 'directory/GET_DIRECTORY_RECORD'
}

export default actions
